import React, { memo } from "react";

interface IProps {
  className?: string;
  size?: number;
}

const CopyIcon: React.FC<IProps> = memo(({ className = "", size = 28 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.17002 24.5C3.51002 24.5 2.94502 24.265 2.47502 23.795C2.00502 23.325 1.77002 22.76 1.77002 22.1V5.3H4.17002V22.1H17.37V24.5H4.17002ZM8.97002 19.7C8.31002 19.7 7.74502 19.465 7.27502 18.995C6.80502 18.525 6.57002 17.96 6.57002 17.3V2.9C6.57002 2.24 6.80502 1.675 7.27502 1.205C7.74502 0.735 8.31002 0.5 8.97002 0.5H19.77C20.43 0.5 20.995 0.735 21.465 1.205C21.935 1.675 22.17 2.24 22.17 2.9V17.3C22.17 17.96 21.935 18.525 21.465 18.995C20.995 19.465 20.43 19.7 19.77 19.7H8.97002Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { CopyIcon };
